module.exports = __webpack_public_path__ + "/images/ico-nav-bars.ff28fe6.svg";